import { gql } from "@urql/core";

const editTopologyConfigurationMut = gql`
  mutation editTopologyConfiguration(
    $id: String!
    $nodeId: String!
    $pimId: String!
    $productName: String!
    $orderCode: OrderCodeInput!
    $presentation: String!
  ) {
    editTopologyConfiguration(
      id: $id
      nodeId: $nodeId
      pimId: $pimId
      productName: $productName
      orderCode: $orderCode
      presentation: $presentation
    ) {
      topologyConfiguration {
        id
        nodeId
        pimId
        presentation
        productName
      }
      topology
    }
  }
`;

const deleteTopologyItemMut = gql`
  mutation deleteTopologyNode(
    $wizardNodeId: String!
    $topologyNodeId: String!
  ) {
    deleteTopologyNode(
      wizardNodeId: $wizardNodeId
      topologyNodeId: $topologyNodeId
    ) {
      topologyNodeId
    }
  }
`;

const TopologyActionsMut = gql`
  mutation invokeTopologyAction($input: InvokeTopologyActionInput!) {
    invokeTopologyAction(input: $input)
  }
`;

const WizardUpdateDetailsMut = `
  mutation editWizardDetails(
   $input:EditWizardDetailsInput!
  ) {
    editWizardDetails(
      input: $input
    ) {
      status
          message
    }
  }
`;

const WizardUpdateZoneMut = gql`
  mutation editZoneDetails($input: EditZoneDetailsInput!) {
    editZoneDetails(input: $input) {
      status
      message
    }
  }
`;

export {
  editTopologyConfigurationMut,
  deleteTopologyItemMut,
  TopologyActionsMut,
  WizardUpdateZoneMut,
  WizardUpdateDetailsMut,
};
